import React from 'react'
import getTime from './formatTime'

export default (props) => {
  return (
    <div className='container'>
      {props.race.splits.map((s, i) => <div className='row' key={i}>
        <div className='col-3 offset-5'>{s.checkpoint.name}</div>
        <div className='col-2'>{s.distance} km</div>
        <div className='col-2'>{(props.row.times[i]) ? getTime(props.row.times[i]) : '-'}</div>
      </div>)}
    </div>
  )
}
